import React from 'react'
import { IconClose } from '@dostavkee/web-ui'
import clsx from 'clsx'

import styles from './payment-form-status.module.scss'

export const PaymentFormStatusFailure: React.FC = () => {
    return (
        <div className={styles['payment-form-status__content']}>
            <div
                className={clsx([
                    styles['payment-form-status__icon'],
                    styles['payment-form-status__icon--failed'],
                ])}
            >
                <IconClose color='var(--extensions-text-and-icon-error)' size={40} />
            </div>
            <div className={styles['payment-form-status__description']}>
                <h1 className={styles['payment-form-status__title']}>Что-то пошло не так</h1>
                <span>Попробуйте ещё раз</span>
            </div>
        </div>
    )
}
